import CustomerInformationDefaultView from "@/app/components/routes/auth_routes/CustomerProfile/CustomerDetails/CustomerInformation/CustomerInformationDefaultView";
import useRouteInfo from "@/app/hooks/useRouteInfo";
import { useRouter } from "@/app/hooks/useRouter";
import { useVMSParams } from "@/app/hooks/useVMSParams";
import { ICustomerProfileState } from "@/app_redux/reducers/slices/auth/customer_profile_slice";
import { Outlet } from "react-router";

const CartPage = () => {
  /* Instantiations Starts */
  const { getRouteKey } = useRouter();
  const { routeState } = useRouteInfo(getRouteKey("CUSTOMER_PROFILE", "id"));
  /* Instantiations Ends */

  /* Redux Starts */
  const { customerDetails, customerPets, customerMembershipStatus } = routeState.state as ICustomerProfileState;
  /* Redux Ends */

  useVMSParams();

  return (
    <div>
      <div className="border-gray-300 border-b-1 static top-0 pt-3">
        <CustomerInformationDefaultView
          handleCustomerEdit={null}
          customerDetails={customerDetails}
          customerMembershipStatus={customerMembershipStatus}
          customerPets={customerPets}
          hidePetsSection={true}
        />
      </div>
      <Outlet />
    </div>
  );
};

export default CartPage;
